import React from 'react';
import { AuthLayout } from '@/components/auth/AuthLayout';
import { LoginForm } from '@/components/auth/LoginForm';

/**
 * Login page wrapper component
 * Combines AuthLayout with LoginForm
 */
const LoginPage: React.FC = () => {
  return (
    <AuthLayout
      title="Welcome Back"
      subtitle="Sign in to your Digital Menu account"
    >
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;